import { render, staticRenderFns } from "./PolicyAgg.vue?vue&type=template&id=e9c669fa&"
import script from "./PolicyAgg.vue?vue&type=script&lang=js&"
export * from "./PolicyAgg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports